(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-product-highlight"]) return;
  try {
    

try {
	document.querySelectorAll('highlight').forEach(function (highlightTag) {
        const highlightName = highlightTag.attributes[0].name;
        const renderedCollectionSection = document.querySelector(`#${highlightName}.blog-product-highlight-wrapper`);
        if (renderedCollectionSection) {
            highlightTag.outerHTML = renderedCollectionSection.outerHTML;
            renderedCollectionSection.parentNode.removeChild(renderedCollectionSection);
            const updatedHighlightSection = document.querySelector(`#${highlightName}.blog-product-highlight-wrapper`);
            updatedHighlightSection.style.display = 'block';
        }
        
    })
}
catch (error) {
    console.log('Error injecting product highlight', error)
}


  } catch(e) { console.error(e); }
})();
})();
